import { gql } from '@apollo/client/core';

export const GET_FILE_EXPORTS = gql`
  query GetFileExports($first: Int!, $page: Int) {
    fileExports(first: $first, page: $page) {
      data {
        id
        type
        status
        progress
        file_name
        error_message
        file_url
        file_size
        metadata
        expires_at
        created_at
      }
      paginatorInfo {
        currentPage
        lastPage
        total
        hasMorePages
      }
    }
  }
`;

export const DOWNLOAD_SCORE_SHEET = gql`
  query DownloadScoreSheet($classroom_id: ID, $subject_id: ID!, $academic_calendar_id: ID!, $programme_id: ID, $level: String) {
    downloadScoreSheet(
      classroom_id: $classroom_id
      subject_id: $subject_id
      academic_calendar_id: $academic_calendar_id
      programme_id: $programme_id
      level: $level
    ) {
      id
      type
      status
      progress
      file_name
      error_message
      created_at
    }
  }
`;

export const DELETE_EXPORT = gql`
  mutation DeleteExport($id: ID!) {
    deleteExport(id: $id)
  }
`;

export const RETRY_EXPORT = gql`
  mutation RetryExport($id: ID!) {
    retryExport(id: $id) {
      id
      type
      status
      progress
      file_name
      error_message
      created_at
    }
  }
`;

export const PROCESS_EXPORT_NOW = gql`
  mutation ProcessExportNow($id: ID!) {
    processExportNow(id: $id) {
      id
      type
      status
      progress
      file_name
      file_url
      file_size
      error_message
      created_at
    }
  }
`;

export const DOWNLOAD_BULK_SCORE_SHEET = gql`
  query DownloadBulkScoreSheet(
    $academic_calendar_id: ID!
    $programme_id: ID
    $level: String
    $classroom_id: ID
    $classroom_section_id: ID
  ) {
    downloadBulkScoreSheet(
      academic_calendar_id: $academic_calendar_id
      programme_id: $programme_id
      level: $level
      classroom_id: $classroom_id
      classroom_section_id: $classroom_section_id
    ) {
      id
      type
      status
      progress
      file_name
      error_message
      created_at
    }
  }
`;

export const DOWNLOAD_BULK_CBT_SCORES = gql`
  query DownloadBulkCbtScores(
    $academic_calendar_id: ID!
    $programme_id: ID
    $level: String
  ) {
    downloadBulkCbtScores(
      academic_calendar_id: $academic_calendar_id
      programme_id: $programme_id
      level: $level
    ) {
      id
      type
      status
      progress
      file_name
      error_message
      created_at
    }
  }
`;

export const DOWNLOAD_BULK_SCORE_SHEET_WITH_CBT = gql`
  query DownloadBulkScoreSheetWithCbt(
    $academic_calendar_id: ID!
    $programme_id: ID
    $level: String
    $classroom_id: ID
    $classroom_section_id: ID
  ) {
    downloadBulkScoreSheetWithCbt(
      academic_calendar_id: $academic_calendar_id
      programme_id: $programme_id
      level: $level
      classroom_id: $classroom_id
      classroom_section_id: $classroom_section_id
    ) {
      id
      type
      status
      progress
      file_name
      error_message
      created_at
    }
  }
`;

export const PREVIEW_BULK_SCORE_SHEET = gql`
  query PreviewBulkScoreSheet(
    $academic_calendar_id: ID!
    $programme_id: ID
    $level: String
    $classroom_id: ID
    $classroom_section_id: ID
  ) {
    previewBulkScoreSheet(
      academic_calendar_id: $academic_calendar_id
      programme_id: $programme_id
      level: $level
      classroom_id: $classroom_id
      classroom_section_id: $classroom_section_id
    ) {
      items { course_code course_title student_count }
      total_courses
      has_template
    }
  }
`;

export const PREVIEW_BULK_CBT_SCORES = gql`
  query PreviewBulkCbtScores(
    $academic_calendar_id: ID!
    $programme_id: ID
    $level: String
  ) {
    previewBulkCbtScores(
      academic_calendar_id: $academic_calendar_id
      programme_id: $programme_id
      level: $level
    ) {
      items {
        course_code
        course_title
        tests { test_title session_count }
        student_count
      }
      unlinked_count
      total_tests
    }
  }
`;

export const IMPORT_BULK_SCORE_SHEET = gql`
  mutation ImportBulkScoreSheet($file: Upload!, $classroom_id: ID!, $academic_calendar_id: ID!) {
    importBulkScoreSheet(file: $file, classroom_id: $classroom_id, academic_calendar_id: $academic_calendar_id) {
      success
      message
      code
    }
  }
`;

export const EXPORT_STATUS_UPDATED_SUBSCRIPTION = gql`
  subscription ExportStatusUpdated($user_id: ID!) {
    exportStatusUpdated(user_id: $user_id) {
      id
      type
      status
      progress
      file_name
      error_message
      file_url
      file_size
      metadata
      expires_at
      created_at
    }
  }
`;
